export const environment = {
  environment: 'DEV',
  name: 'Desenvolvimento',
  production: false,
  cms_latam_api: {
    apiKey: 'KAfeHXFXjsyNmjpDGM/JhVB0gSaILaORPxEZoj0fC+K8iSya',
    baseUrl: 'https://api-aks-dev.meucontinental.com.br',
  },
  api: {
    baseUrl: 'https://dev-api.electrolux.com.br',
    clientId: '94d00f7f-d03e-45e7-8d97-12682a053aa2',
  },
}
